import { render, staticRenderFns } from "./VerFilaConsultorio.vue?vue&type=template&id=5d416838&"
import script from "./VerFilaConsultorio.vue?vue&type=script&lang=js&"
export * from "./VerFilaConsultorio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports